import {Injectable} from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {PropertyResponse} from '../model/property-response.model';
import {Property} from '../model/property.model';

@Injectable({providedIn: 'root'})
export class PropertyResponseMapper extends Mapper<PropertyResponse, Property> {
  override map(source: PropertyResponse): Property {
    return new Property(
      source.name,
      source.fieldType,
      source.value,
      source.propertyType,
    )
  }
}
